import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

export const sliderTestimonyList = (slider: HTMLElement) => {
    new Swiper(slider, {
        modules: [Pagination, Navigation],
        pagination: {
            el: slider.querySelector('.swiper-pagination') as HTMLElement,
            clickable: true,
        },
        navigation: {
            nextEl: slider.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: slider.querySelector('.swiper-button-prev') as HTMLElement,
        },
        breakpoints: {
            500: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: false,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
                loop: true,
            },
        },
        slidesPerView: 1,
        spaceBetween: 24,
        centeredSlides: true,
    })
}
